module.exports = __webpack_public_path__ + "static/linuz90-5f3a3035a9f0a3343aa8fddfcc069dc0.jpg";